import type { IconName } from "@/lib/icons";
import { industries } from "@/content/industries";

export type NavItem = {
  label: string;
  href: string;
  description?: string;
  icon?: IconName;
  external?: boolean;
};

// Primary CTA — booking is handled through /contact (there is no /book-a-call page).
export const primaryCta: NavItem = { label: "Book a call", href: "/contact" };

// Industries dropdown — driven by real industry data so slugs are always valid.
export const industriesMenu: NavItem[] = industries.map((i) => ({
  label: i.name,
  href: `/industries/${i.slug}`,
  description: i.tagline,
  icon: i.icon,
}));

// Top-level items; `menu: "industries"` renders the Industries mega-dropdown.
export type PrimaryNavItem = {
  label: string;
  href: string;
  menu?: "industries";
};

export const primaryNav: PrimaryNavItem[] = [
  { label: "Solutions", href: "/#solutions" },
  { label: "Industries", href: "/industries", menu: "industries" },
  { label: "Blog", href: "/blog" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];

// SimpleHeader (legal pages) — trimmed nav, valid routes only.
export const simpleNav: NavItem[] = [
  { label: "Industries", href: "/industries" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/contact" },
];

// FullFooter columns (valid routes only).
export const footerColumns: { heading: string; links: NavItem[] }[] = [
  {
    heading: "Company",
    links: [
      { label: "About", href: "/about" },
      { label: "Industries", href: "/industries" },
      { label: "Blog", href: "/blog" },
      { label: "Contact", href: "/contact" },
    ],
  },
  {
    heading: "Resources",
    links: [
      { label: "Blog", href: "/blog" },
      { label: "Sitemap", href: "/sitemap" },
      { label: "llms.txt", href: "/llms.txt", external: true },
    ],
  },
];

export const legalNav: NavItem[] = [
  { label: "Privacy", href: "/privacy" },
  { label: "Terms", href: "/terms" },
  { label: "Disclaimer", href: "/disclaimer" },
];
